import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Crop = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.231 71.062h-7.264V23.959h-.051c.003-.07.021-.135.021-.206a4.773 4.773 0 0 0-4.772-4.772H28.99v-7.068a2.693 2.693 0 0 0-2.693-2.693h-4.571a2.692 2.692 0 0 0-2.693 2.693v7.068h-7.264a2.693 2.693 0 0 0-2.693 2.693v4.571a2.692 2.692 0 0 0 2.693 2.693h7.264v47.103h.052c-.003.07-.021.135-.021.206a4.773 4.773 0 0 0 4.772 4.772H71.01v7.068a2.693 2.693 0 0 0 2.693 2.693h4.571a2.692 2.692 0 0 0 2.693-2.693v-7.068h7.264a2.693 2.693 0 0 0 2.693-2.693v-4.571a2.693 2.693 0 0 0-2.693-2.693zm-59.241.001V28.937h42.02v42.125H28.99z"
  }));
});
Crop.displayName = 'Crop';
export var CropDimensions = {
  height: 100,
  width: 100
};